// extracted by mini-css-extract-plugin
export var aboveInput = "_mh-0";
export var actionButton = "_mh-5";
export var actionButtonContainer = "_mh-1";
export var actionIcon = "_mh-6";
export var aiInfoContainer = "_mh-2";
export var attachmentWrapper = "_mh-7";
export var bold = "_mh-3";
export var checkIcon = "_mh-8";
export var clickingRecipientBar = "_mh-11";
export var commentThreadSwitch = "_mh-a";
export var draftImage = "_mh-b";
export var draftImageContainer = "_mh-c";
export var draftImages = "_mh-e";
export var editButton = "_mh-g";
export var editor = "_mh-f";
export var editorContainer = "_mh-y";
export var editorErrorTooltipWrapper = "_mh-9";
export var headerDivider = "_mh-h";
export var icon = "_mh-i";
export var info = "_mh-j";
export var internal = "_mh-n";
export var internalDivider = "_mh-k";
export var internalMessage = "_mh-l";
export var messageInputCard = "_mh-m";
export var messageInputForm = "_mh-o";
export var messageInputFormInternal = "_mh-p";
export var options = "_mh-q";
export var publicMessageCustomer = "_mh-s";
export var publicMessageMerchant = "_mh-r";
export var removeImageButton = "_mh-d";
export var replyButtons = "_mh-t";
export var showSignatureButton = "_mh-u";
export var spinner = "_mh-v";
export var verticalButtonDivider = "_mh-4";
export var visibilitySelector = "_mh-w";
export var warning = "_mh-x";
export var wrappingText = "_mh-z";
export var writingInternalNoteTopBorder = "_mh-10";